export * from './IconPdfFile';
export { default as IconPdfFile } from './IconPdfFile';
